import React from 'react'
import AppToggle from '../../../../components/AppToggle'

export default function MobileAppFeatureCard({
  title,
  icon,
  badge,
  features = [],
  values = {},
  onToggle,
}) {
  return (
    <div className="rounded-3xl border border-outline-variant/25 bg-surface-container-lowest p-6 shadow-xs">
      {/* ── Card Header ── */}
      <div className="flex items-center justify-between border-b border-outline-variant/15 pb-4 mb-5">
        <div className="flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-2xl bg-primary/10 text-primary">
            <span className="material-symbols-outlined text-lg">{icon}</span>
          </span>
          <div>
            <h3 className="font-display text-sm font-extrabold text-on-surface">{title}</h3>
            <p className="text-[11px] text-on-surface-variant">Configure module visibility for student &amp; parent app</p>
          </div>
        </div>

        {badge && (
          <span className="rounded-xl bg-surface-container-high px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-on-surface-variant">
            {badge}
          </span>
        )}
      </div>

      {/* ── Feature Switches List ── */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
        {features.map((feat) => {
          const isChecked = Boolean(values[feat.key])
          return (
            <div
              key={feat.key}
              onClick={() => onToggle(feat.key, !isChecked)}
              className={`flex items-center justify-between gap-3 rounded-2xl border p-3.5 transition-all cursor-pointer select-none ${
                isChecked
                  ? 'border-primary/30 bg-primary/[0.03] hover:border-primary/50'
                  : 'border-outline-variant/20 bg-surface-container-low/30 hover:border-outline-variant/40'
              }`}
            >
              <div className="flex items-center gap-3">
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-xl transition ${
                    isChecked
                      ? 'bg-primary/10 text-primary'
                      : 'bg-surface-container-high text-on-surface-variant'
                  }`}
                >
                  <span className="material-symbols-outlined text-base">{feat.icon}</span>
                </span>

                <div>
                  <h4 className="text-xs font-bold text-on-surface leading-snug">{feat.label}</h4>
                  <p className="text-[10px] text-on-surface-variant line-clamp-1">{feat.description}</p>
                </div>
              </div>

              <div onClick={(e) => e.stopPropagation()}>
                <AppToggle
                  checked={isChecked}
                  onChange={(nextVal) => onToggle(feat.key, nextVal)}
                  ariaLabel={`Toggle ${feat.label}`}
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
